import React from 'react'
import TitleCaptionDescription from './TitleCaptionDescription'
import teleponeicon from '../../images/telefonoicon.png'
import mailicon from '../../images/mailicon.png'

export default function StoriaPage(params) {
    window.scrollTo(0, 0)
    return(
    <div className="container"> 
        <div className="row" style={{marginTop:"20px"}}>
            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{paddingLeft:"0",paddingRight:"0"}}>   
                <TitleCaptionDescription title={"DOVE TROVARMI"} marginTop={"20px"}>
                Via Vittoria, 80 • 00187 Roma    
                </TitleCaptionDescription>
                
                <TitleCaptionDescription title={"COME ARRIVARE"} marginTop={"20px"}>
                È possibile raggiungere <b>Via Vittoria</b> con la linea A della metropolitana scendendo alla fermata <b>Piazza di Spagna</b>. <br/> In alternativa è possibile lasciare l’auto nel parcheggio sotterraneo di Villa Borghese, raggiungibile dal Muro Torto.
                </TitleCaptionDescription>

                <TitleCaptionDescription title={"ORARI"} marginTop={"20px"}>
                <p>
                Martedì - Sabato <br/>
                10:30 - 18:30
                </p>
                <p>
                Lunedì <br/>
                15:00 - 18:30
                </p>
                </TitleCaptionDescription>
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">  
                <iframe title="mappaAlfonsi" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2969.363134393219!2d12.476198015442005!3d41.90655177921992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f6055d765c907%3A0x761a03a28c7da45c!2sVia%20Vittoria%2C%2080%2C%2000187%20Roma%20RM!5e0!3m2!1sit!2sit!4v1576422933888!5m2!1sit!2sit" width="600" height="450" frameborder="0" style={{border:"0",width:"100%",backgroundColor:"#bdbdbd"}} allowfullscreen=""></iframe>
            </div>
            <div className="col-12" style={{marginTop:"15px"}}>
                <div className="row">
                    <div className="col-6">
                    <div><img src={teleponeicon} style={{height:"30px"}} alt=""/></div>
                        <div>+39 06 69380447</div>
                    </div>
                    <div className="col-6">
                        <div><img src={mailicon} alt="" style={{height:"30px"}}/></div>
                        <div><a href="mailto:info@riccardoalfonsi.it" style={{color:"black"}}>info@riccardoalfonsi.it</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}